// src/stage2/sceneInterior/DoorTrigger.jsx
import { useRef, useMemo } from "react";
import { useThree, useFrame } from "@react-three/fiber";
import * as THREE from "three";

export function DoorTrigger({
  mode = "enter",
  onTrigger,
  debug = false,
  boxSize = [4, 2.5, 1], // width, height, depth
}) {
  const { camera } = useThree();
  const firedRef = useRef(false);

  // ✅ track previous "inside" state so we only fire on crossing
  const wasInsideRef = useRef(false);

  const targetPos = useMemo(() => {
    return mode === "enter"
      ? new THREE.Vector3(0, 3, 23.25)      // OUTSIDE door
      : new THREE.Vector3(14, 0.5, 0);   // INSIDE door
  }, [mode]);

  const half = useMemo(
    () => new THREE.Vector3(boxSize[0] / 2, boxSize[1] / 2, boxSize[2] / 2),
    [boxSize]
  );

  useFrame(() => {
    const p = camera.position;

    const inside =
      Math.abs(p.x - targetPos.x) <= half.x &&
      Math.abs(p.y - targetPos.y) <= half.y &&
      Math.abs(p.z - targetPos.z) <= half.z;

    // ✅ only trigger when we ENTER the box (outside -> inside)
    if (!firedRef.current && inside && !wasInsideRef.current) {
      console.log(`[DoorTrigger:${mode}] ✅ TRIGGERED! (box enter)`);
      firedRef.current = true;
      onTrigger?.();

      setTimeout(() => {
        firedRef.current = false;
      }, 1200);
    }

    // update last frame state
    wasInsideRef.current = inside;
  });

  return (
    <>
      {debug && (
        <mesh position={[targetPos.x, targetPos.y, targetPos.z]}>
          <boxGeometry args={boxSize} />
          <meshStandardMaterial color="hotpink" transparent opacity={0.35} />
        </mesh>
      )}
    </>
  );
}
